export const SKILLS_CATALOGITEMMAP_LOAD = 'SKILLS_CATALOGITEMMAP_LOAD';

export function fetchSkillsCatalogItemMap() {
    return {
        type: SKILLS_CATALOGITEMMAP_LOAD,
    };
}
